<template>
    <div class="node_manage">
        <div class="bread_crumb">
            业务管理 > 节点查询
        </div>
        <div class="main">
            <div class="top">
                <div class="left">
                    <span>节点查询</span>
                    <span>Node Management</span>
                </div>
                <div class="right">
                    <el-input v-model="ruleForm.keywords" placeholder="请输入节点编码或节点名称" class="mr20" style="width:280px;"></el-input>
                    <el-button size="medium" class="mr20 pub_green_btn" @click="nodeList()">搜索</el-button>
                </div>
            </div>
            <div class="table_list">
                <div class="table_wrap">
                    <el-table
                        border
                        class="table_data"
                        :data="tableData"
                        style="width: 100%">
                        <el-table-column prop="nodeIdcode" label="节点编码" min-width="180" align="center"></el-table-column>
                        <el-table-column prop="nodeName" label="节点名称" min-width="180" align="center"></el-table-column>
						<el-table-column prop="nodeProfile" label="节点简介" min-width="280" align="center"></el-table-column>
                       <!-- <el-table-column prop="nodeType" label="类型" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{scope.row.nodeType==0?"省级节点":"市级节点"}}</span>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="appSecret" label="授权码" min-width="180" align="center"></el-table-column>
                        <el-table-column label="审核状态" width="120" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.examState==-1" class="circle red">审核不通过</span>
                                <span v-else-if="scope.row.examState==0" class="circle grey">待审核</span>
                                <span v-else-if="scope.row.examState==100" class="circle green">审核通过</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="state" label="节点状态" width="120" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.authExamineState==100&&scope.row.examState==100">
                                    <span v-if="scope.row.state==0" class="circle grey">禁用</span>
                                    <span v-else-if="scope.row.state==1" class="circle green">启用</span>
                                </div>
                                <div v-else>
                                    <span v-if="scope.row.examState!=100" class="circle grey">添加中</span>
                                    <span v-else class="circle green">已添加</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="120" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" @click="nodeApplyDetail(scope.row)">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        class="laypage_list"
                        @current-change="currChange"
                        :page-size="ruleForm.limit"
                        :current-page="ruleForm.page"
                        background
                        layout="prev, pager, next,total"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 节点详情弹框 -->
        <el-dialog
            title="节点详情"
            :visible.sync="detailDialog"
            width="50%">
            <div class="form_dialog node_detail_dialog">
                <ul class="list">
                    <li>
                        <label>节点名称：</label>
                        <span>{{detailObj.nodeName||''}}</span>
                    </li>
					<li>
					    <label>节点简介：</label>
					    <span>{{detailObj.nodeProfile||''}}</span>
					</li>
                    <li>
                        <label>单位名称：</label>
                        <span>{{detailObj.unitName||''}}</span>
                    </li>
                    <li>
                        <label>统一社会信用代码：</label>
                        <span>{{detailObj.unitCode||''}}</span>
                    </li>
                    <li>
                        <label>注册地址：</label>
                        <span>{{detailObj.unitAddress||''}}</span>
                    </li>
                    <li class="img_wrap">
                        <label>营业执照：</label>
                        <el-image 
                            :z-index="3000"
                            :src="detailObj.license"
                            :preview-src-list="srcList">
                        </el-image>
                        <!-- <img :src="detailObj.license" alt=""> -->
                        <!-- <el-button class="look_img" size="mini" round>查看原图</el-button> -->
                    </li>
                     <li>
                        <label>联系人：</label>
                        <span>{{detailObj.linkman||''}}</span>
                    </li>
                     <li>
                        <label>手机：</label>
                        <span>{{detailObj.linkphone||''}}</span>
                    </li>
                     <li>
                        <label>电子邮箱：</label>
                        <span>{{detailObj.email||''}}</span>
                    </li>
                </ul>
                <div class="btn_wrap">
                    <el-button class="pub_green_btn" @click="detailDialog=false">关闭</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {nodeList} from '@/api/admin'
export default {
    name:'NodeRegister',
    data() {
      return {
        ruleForm: {
          keywords: '',//模糊查询
          page: 1,//页码
          limit: 10,//分页大小
        },
        tableData: [],
        total:0,//总条数
        detailDialog:false,//节点详情弹框
        detailObj:{},//节点详情
        srcList: []
      }
    },
    mounted(){
        this.nodeList()
    },
    methods:{
        nodeList(val){//节点查询
            this.ruleForm.page=val||1
            nodeList(this.ruleForm).then(res=>{
                // console.log('节点查询')
                // console.log(JSON.parse(JSON.stringify(res.data.list)))
                this.tableData=res.data.list||[]
                this.total=res.data.total
            }).catch(()=>{
                this.tableData=[]
                this.total=0
            })
        },
        currChange(val){//页码变化
            this.nodeList(val)
        },
        nodeApplyDetail(v){//节点申请详情
            this.srcList[0]=v.license||[]
            this.detailObj=v
            this.detailDialog=true
        },
    }
}
</script>

<style lang='scss' scoped>
    .node_manage{
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .mr20{
            margin-right: 20px;
        }
        .bread_crumb{
            flex: none;
            font-size: 16px;
            font-weight: 600;
            color: #333;
        }
        .main{
            overflow-x: hidden;
            flex: 1;
            background-color: #fff;
            border-radius: 10px;
            margin-top: 20px;
            padding: 40px 50px;
            box-sizing: border-box;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            .top{
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #E6E6E6;
                padding-bottom: 30px;
                .left{
                    span:nth-child(1){
                        font-size: 20px;
                        font-weight: 600;
                        color: #00AA73;
                    }
                    span:nth-child(2){
                        font-size: 16px;
                        font-weight: 400;
                        color: #808080;
                        margin-left: 10px;
                    }
                }
                .right{
                    display: flex;
                    align-items: center;
                    label{
                        flex: none;
                    }
                    .el-button{
                        border: 2px solid #00AA73;
                        width: 115px;
                        // height: 40px;
                        font-size: 16px;
                        // margin-right: 60px;
                        font-weight: 700;
                        color: #00AA73;
                    }
                }
            }
            .table_list{
                flex-grow: 1;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                .table_wrap{
                    max-height:100%;
                    .table_data{
                        border: 1px solid #EBEEF5;
                        height: calc(100% - 54px);
                        ::v-deep {.el-table__body-wrapper{
                            overflow-y: auto;
                            height: calc(100% - 46px);
                        }
                    }
                    }
                    .laypage_list{
                        text-align: right;
                        margin-top: 20px;
                    }
                    .circle{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &::before{
                            display: inline-block;
                            content: '';
                            width: 14px;
                            height: 14px;
                            border-radius: 50%;
                            margin-right: 5px;
                        }
                    }
                    .grey{
                        &::before{
                            background-color: #BDBDBD;
                        }
                    }
                    .green{
                        &::before{
                            background-color: #00AA73;
                        }
                    }
                    .red{
                        &::before{
                            background-color: #FF4D4F;
                        }
                    }
                }
            }
        }
        .form_dialog{
            border-top: 1px solid #E6E6E6;
            padding-top: 40px;
            .btn_wrap{
                text-align: center;
                margin-top: 50px;
            }
        }
        .node_detail_dialog{
            .list{
                // border: 1px solid #f00;
                >li{
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                    label{
                        flex: none;
                        font-size: 16px;
                        color: #333;
                        display: inline-block;
                        width: 150px;
                        // border: 1px solid #0f0;
                        text-align: right;
                        font-weight: 500;
                    }
                    span{
                        flex: 1;
                        font-size: 16px;
                        color: #666;
                        margin-left: 10px;
                        // border: 1px solid #f0f;
                    }
                }
                .img_wrap{
                    // border: 1px solid #f0f;
                    display: flex;
                    align-items: start;
                    .el-image{
                        // border: 1px solid #0f0;
                        max-width: 357px;
                        // max-height: 255px;
                        margin-left: 10px;
                    }
                    .look_img{
                        font-size: 12px;
                        color: #999;
                        margin-left: 20px;
                    }
                }
            }
            .btn_wrap{
                margin-top: 0;
                .pub_green_btn{
                    width: 135px;
                }
            }
        }
        ::v-deep {.el-dialog__body{
            padding: 20px 50px 40px;
            box-sizing: border-box;
        }
    }
    ::v-deep {.el-dialog__header{
            text-align: center;
            font-weight: 600;
        }
    }
    }
</style>